<template>
  <VCard
    :loading="isLoadingLogOut"
    class="p-0 shadow-none border-radius-8 px-2 pt-2 pb-4 position-relative"
  >
    <template #progress>
      <SSpinner :dialog="true" />
    </template>
    <VCardTitle class="d-flex">
      <VRow>
        <VCol
          cols="11"
          class="p-0 d-flex align-center"
        >
          <span class="heading-6">
            {{ $t('logOut.title') }}
          </span>
        </VCol>
        <VCol
          cols="1"
          class="p-0"
        >
          <VBtn
            class="grey-lighten-4 box-shadow-elevation-6"
            icon
            data-test="close-logout-dialog"
            @click="$emit('closeDialog')"
          >
            <VIcon class="textPrimary--text">mdi-close</VIcon>
          </VBtn>
        </VCol>
      </VRow>
    </VCardTitle>
    <VCardText class="pt-7">
      <VRow justify="center">
        <img
          :src="require('@slg/web-customer-shared/src/assets/img/hands-key.svg')"
          :alt="$t('imageAlt.logOutIllustration')"
        >
      </VRow>
    </VCardText>
    <VCardActions class="px-0 pb-0 pt-4">
      <div class="d-flex align-center justify-content-between w-100">
        <div class="w-50 pr-2">
          <VBtn
            v-blur
            class="w-100 body-2 border-radius-8"
            outlined
            large
            color="textTertiary"
            data-test="cancel-logout-button"
            @click="$emit('closeDialog')"
          >
            {{ $t('logOut.cancel') }}
          </VBtn>
        </div>
        <div class="w-50 pl-2">
          <VBtn
            v-blur
            class="w-100 body-2 border-radius-8"
            data-test="logOutButton"
            dark
            large
            color="brandingPrimary"
            @click="$emit('logOut'), $emit('closeDialog')"
          >
            {{ $t('logOut.logOut') }}
          </VBtn>
        </div>
      </div>
    </VCardActions>
  </VCard>
</template>

<script lang="ts">
export default {
  name: 'LogoutDialog',
};
</script>

<script setup lang="ts">
import SSpinner from '@slg/web-customer-shared/src/components/common/SSpinner';

defineProps({
  isLoadingLogOut: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped lang="scss">
</style>
